<ng-template #errordeleteapp let-c="close" let-d="dismiss">
  <div class="modal-body error-modal">
    <div class="d-flex flex-column align-items-center">
      <h2 class="text-center">
        {{ 'settings-clients-error-form-impossible' | translate }}
        {{ appSelected()?.packageName }}, {{ 'settings-clients-error-form-app' | translate }}
      </h2>
      <table>
        <tbody>
          @for (policy of appSelected()?.policy; track $index) {
            <tr>
              <td class="text-start">{{ policy?.name }}</td>
              <td class="text-end">{{ policy?.status }}</td>
            </tr>
          }
        </tbody>
      </table>
      <div class="d-flex flex-row justify-content-around">
        <button type="button" class="btn btn-outline-primary"
          (click)="c('Save changes')">{{ 'continue' | translate }}</button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #errordeleteclient let-c="close" let-d="dismiss">
  <div class="modal-body error-modal">
    <div class="d-flex flex-column align-items-center">
      @if (errorAppPolicy()) {
        <h2 class="text-center">
          {{ 'settings-clients-error-form-impossible' | translate }} {{ clientSelected()?.name }},
          {{ 'settings-clients-error-form-client' | translate }}
        </h2>
        @for (item of mapClient() | keyvalue: originalOrder; track item) {
          <div class="d-flex flex-row tableClientApp">
            <img class="headimg" src="assets/icons/logosOS/{{item.key}}.svg">
            <table>
              @if (item.value && item.value.length > 0) {
                <tbody>
                  @for (app of item.value; track app) {
                    <tr>
                      @if (app && app.policy && app.policy.length > 0) {
                        <td class="text-end">{{ app?.packageName }}</td>
                      }
                    </tr>
                  }
                </tbody>
              }
            </table>
          </div>
        }
      }
      @if (error()) {
        <h2 class="error">{{ error()!.error?.error }}</h2>
        <h3 class="error">{{ error()!.error?.message }}</h3>
      }
      <div class="d-flex flex-row justify-content-around">
        <button type="button" class="btn btn-outline-primary"
          (click)="c('Save changes')">{{ 'continue' | translate }}</button>
      </div>
    </div>
  </div>
</ng-template>

<div class="capsule main">
  <h1>{{ 'settings-clients-h1' | translate }}</h1>
  @if (!loadingOerror()) {
    <div ngbAccordion>
      <div ngbAccordionItem="clientsItem" #clientsItem="ngbAccordionItem">
        <div ngbAccordionHeader>
          <button ngbAccordionToggle class="accordion-button">
            <div class="d-flex title justify-content-between align-items-center">
              <h2>{{ 'setting-nav-clients' | translate }}</h2>
              <div class="tags d-flex flex-row justify-content-around align-items-center">
                <app-form-client-app-settings [type]="'add-client'" (addClient)="addClient($event)">
                </app-form-client-app-settings>
                <div class="tag d-flex flex-row justify-content-center">
                  <h3 class="name total">{{ 'security-policies-details-total' | translate }}</h3>
                  <h3 class="value">{{ lClients()?.length || 0 }}</h3>
                </div>
              </div>
            </div>
          </button>
        </div>
        <div ngbAccordionCollapse>
          <div class="d-flex flex wrap">
            <div class="canevasList">
              <ul>
                @for (cli of lClients(); track cli) {
                  <li class="d-flex flex-row justify-content-between align-items-center elem"
                    type="button" id="elem{{cli.id}}"
                    (click)="clientSelectionnee(cli); scroolTo()">
                    <h3 class="name">{{ cli.name }}</h3>
                    <div class="d-flex flex-row justify-content-between align-items-center icons">
                      <app-form-client-app-settings [type]="'delete'" [client]="cli"
                        (deleteClient)="deleteClient($event)"></app-form-client-app-settings>
                    </div>
                    <img class="side-arrow" src="assets/icons/ComprReport/down-arrow.svg">
                  </li>
                }
              </ul>
            </div>
            <div id="clientApplications" hidden="hidden">
              <div class="d-flex flex-column justify-content-center align-items-center">
                <div ngbAccordion id="accordion-details">
                  <div ngbAccordionItem="applicationsItem" #applicationsItem="ngbAccordionItem">
                    <div ngbAccordionHeader>
                      <button ngbAccordionToggle class="accordion-button">
                        <div class="d-flex title justify-content-between align-items-center">
                          <h2>{{ 'settings-clients-h3' | translate }}</h2>
                          <div class="tags d-flex flex-row justify-content-around align-items-center">
                            <app-form-client-app-settings [type]="'add-app'" [client]="clientSelected()"
                              (addApp)="addApplication($event)"></app-form-client-app-settings>
                            <div class="tag d-flex flex-row justify-content-center">
                              <h3 class="name total">{{ 'security-policies-details-total' | translate }}</h3>
                              <h3 class="value">{{ lClientApplications().length || 0 }}</h3>
                            </div>
                          </div>
                        </div>
                      </button>
                    </div>
                    <div ngbAccordionCollapse>
                      <div class="d-flex flex wrap">
                        <div class="canevasList">
                          @if (lClientApplications().length > 0) {
                            @for (item of mapClient() | keyvalue: originalOrder; track item) {
                              <div class="d-flex flex-row tableClientApp">
                                <img class="headimg" src="assets/icons/logosOS/{{item.key}}.svg">
                                <table>
                                  @if (item.value && item.value.length > 0) {
                                    <tbody>
                                      @for (app of item.value; track app) {
                                        <tr>
                                          <td class="text-center">{{ app?.packageName }}</td>
                                          <td class="text-end">
                                            <app-form-client-app-settings [client]="clientSelected()"
                                              [application]="app" [type]="'delete'"
                                              (deleteApp)="deleteApplication($event)">
                                            </app-form-client-app-settings>
                                          </td>
                                        </tr>
                                      }
                                    </tbody>
                                  }
                                </table>
                              </div>
                            }
                          }
                          @if (lClientApplications().length == 0) {
                            <div class="d-flex flex-row justify-content-around align-items-center noItems">
                              <img id="notfound" src="assets/images/Components/notfoundalone.svg">
                              <h3>{{ 'settings-clients-no-app' | translate }}</h3>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                  <div ngbAccordionItem="refPoliciesItem" #refPoliciesItem="ngbAccordionItem">
                    <div ngbAccordionHeader>
                      <button ngbAccordionToggle class="accordion-button">
                        <div class="d-flex title justify-content-between align-items-center">
                          <h2>{{ 'ref-policies-title-client-settings' | translate }}</h2>
                          <div class="tags d-flex flex-row justify-content-around align-items-center">
                            <app-form-ref-policies-settings [action]="'add-client-ref'" [client]="clientSelected()"
                              (addRefPolicy)="addRefPolicy($event)">
                            </app-form-ref-policies-settings>
                            <div class="tag d-flex flex-row justify-content-center">
                              <h3 class="name total">{{ 'security-policies-details-total' | translate }}</h3>
                              <h3 class="value">{{ lRefPolicies().length || 0 }}</h3>
                            </div>
                          </div>
                        </div>
                      </button>
                    </div>
                    <div ngbAccordionCollapse>
                      <div class="d-flex flex wrap">
                        <div class="canevasList">
                          @if (lRefPolicies() && lRefPolicies().length > 0) {
                            <ul>
                              @for (refPolicy of lRefPolicies(); track refPolicy) {
                                <li class="d-flex flex-row justify-content-between align-items-center elem">
                                  <h3 class="name">{{ refPolicy.name }}</h3>
                                  <div class="d-flex flex-row justify-content-between align-items-center icons">
                                    <app-form-ref-policies-settings [action]="'edit-client-ref'" [client]="clientSelected()"
                                      [refPolicy]="refPolicy" (patchRefPolicy)="patchRefPolicy($event)">
                                    </app-form-ref-policies-settings>
                                    <app-form-ref-policies-settings [action]="'delete'" [refPolicy]="refPolicy"
                                      (deleteRefPolicy)="deleteRefPolicy($event)">
                                    </app-form-ref-policies-settings>
                                  </div>
                                </li>
                              }
                            </ul>
                          } @else {
                            <div class="d-flex flex-row justify-content-around align-items-center noItems">
                              <img id="notfound" src="assets/images/Components/notfoundalone.svg">
                              <h3>{{ 'ref-policies-no-default-ref-found' | translate }}</h3>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  } @else {
    <app-loading-error [boolean]="true" [message]="'waiting-for-clients' | translate">
    </app-loading-error>
  }
  <ng-template #loading>
    <app-loading-error [boolean]="true" [message]="'waiting-for-clients' | translate">
    </app-loading-error>
  </ng-template>
</div>
<app-toast-component></app-toast-component>
